import React, { useEffect } from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import speaker from '../../assets/speaker.png';
import Cookies from 'js-cookie';

export const GpcPopup = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
 
  useEffect(() => {
    if (!Cookies.get('privateToken')) {
      Cookies.set("displayGpc", true);
    }
  }, []);

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleGotIt} open={props.open}>
      <Box className={classes.root}>
        
        <Box className={classes.cardBodyContainer}>
            <Box className={classes.imageContainer}>
                <img src={speaker} style={{ width: '60px', height: '60px'}}/>
            </Box> 
            <Box className={classes.imageContainer}>
                <span className={classes.request}>GPC Signal Acknowledgement</span>                
            </Box> 
             <Typography className={classes.paragraph}>{Cookies.get("privateLabelUrl")?.toUpperCase()} received and honored your Global Privacy Control (GPC) signal. In accordance with the CCPA, we have processed this signal as a request to opt you out of the sale and sharing of personal information as applicable.</Typography>
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={props.handleGotIt}
            >Okay</Button>
        </Box>
      </Box> 
    </Dialog>
  )
}
